import {Component, Input, OnInit} from '@angular/core';
import {TreatyApiService} from "../../services/treaty.service";
import {Country, TreatySummaryViewModel} from "../../models/treaty.models";
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';

@Component({
    standalone: false,
    selector: 'particle-treaty-summary',
  templateUrl: './treaty-summary.component.html',
  styleUrls: ['./treaty-summary.component.scss']
})
export class TreatySummaryComponent implements OnInit {
  country1: Country;
  country2: Country;
  id: string;
  id1: string;
  id2: string;
  treatySummary: TreatySummaryViewModel;
  @Input() info: {country1: Country , country2: Country};
  constructor(private treatyService: TreatyApiService, private fuseSplashService: FuseSplashScreenService) { }

  ngOnInit() {
    console.log(this.info);
    this.country1 = this.info.country1;
    this.country2 = this.info.country2;
    this.id = `${this.info.country1.id}-${this.info.country2.id}`;
    this.id1 = `${this.info.country1.id}`;
    this.id2 = `${this.info.country2.id}`;
    this.fuseSplashService.show();
    this.treatyService.getTreatySummary(this.id1, this.id2).subscribe( data => {
      this.fuseSplashService.hide();
      this.treatySummary = data;
    })
  }

}
